exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-2866cdcb]{padding:20px 15px 0 10px}.content[data-v-2866cdcb] .el-textarea__inner{resize:none}.content[data-v-2866cdcb] .el-select,.content[data-v-2866cdcb] .el-input{width:100%}.from-foot-btn button[data-v-2866cdcb]{width:auto;height:auto}\n", ""]);

// exports
